import type { TInWorkOrFinishedDealsSortField } from '@crm/entities/deal';

export const DEALS_TABLE_LIMIT_OPTIONS = {
    headerHeight: 40,
    maxLimit: 100,
    rowGap: 4,
    rowHeight: 50,
};

export const DEALS_TABLE_SORT_FIELDS = {
    nextContactAt: 'next_contact_at',
    paymentAt: 'payment_at',
} as const satisfies Record<string, TInWorkOrFinishedDealsSortField>;

export const DEALS_TABLE_ALLOW_SORT_CLEAR = Object.keys(DEALS_TABLE_SORT_FIELDS).length > 1;
